import { render, staticRenderFns } from "./SingleNotification.vue?vue&type=template&id=99fc9a02"
import script from "./SingleNotification.vue?vue&type=script&lang=js"
export * from "./SingleNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports